import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  setSort,
  setFilters as setStoreFilters,
} from '../../../../js/lib/redux/slices/booking'
import SanitizeHtml from '../../Base/SanitizeHtml/SanitizeHtml'
import { Modal } from '@mui/material'

const Filters = ({
  drawer,
  onCloseDrawer,
  sortOptions,
  filterCars,
  fleet,
  carsData,
  loadingFleetData,
  isInpath,
}) => {
  const { dictionary, records } =
    window.fleetData || window.bookingData || window.inpathData
  const { brands, types, categories } = records
  const { filters: storeFilters, sort } = useSelector((state) => state.booking)
  const dispatch = useDispatch()
  const [filters, setFilters] = useState(storeFilters)
  const carsCount = filterCars(filters)?.length
  const [disabledFilters, setDisabledFilters] = useState([])

  useEffect(() => {
    setFilters(storeFilters)
  }, [storeFilters])

  const handleChange = (name, code) => {
    const newFilters = { ...filters }
    if (code === 'all') {
      const allOptions = filtersList.find(
        (filter) => filter.name === name
      ).options

      if (!filters[name] || filters[name]?.length < allOptions.length) {
        newFilters[name] = allOptions.map((opt) => opt.code)
      } else {
        delete newFilters[name]
      }
    } else {
      if (!newFilters[name]) newFilters[name] = [code]
      else {
        if (newFilters[name].includes(code)) {
          newFilters[name] = newFilters[name].filter((item) => item !== code)
        } else {
          newFilters[name] = [...newFilters[name], code]
        }
      }
    }

    setFilters(newFilters)
    if (!drawer) {
      dispatch(setStoreFilters(newFilters))
    }
  }

  const handleClear = () => {
    setFilters(storeFilters.country ? { country: storeFilters.country } : {})
  }
  const handleApply = () => {
    dispatch(setStoreFilters(filters))
    onCloseDrawer()
  }

  const checkAvailableFilters = () => {
    if (loadingFleetData && fleet) return
    const newDisabledFilters = []
    for (const filter of filtersList) {
      for (const option of filter.options) {
        // if (filters[filter.name]?.includes(option.code)) continue
        const newFilters = {
          ...filters,
          [filter.name]: [option.code],
        }
        const filteredCars = filterCars(newFilters)
        if (filteredCars.length === 0) {
          newDisabledFilters.push(`${filter.name}-${option.code}`)
          if (filters[filter.name]?.includes(option.code)) {
            setFilters((old) => ({
              ...old,
              [filter.name]: old[filter.name].filter(
                (code) => code !== option.code
              ),
            }))
          }
        }
      }
    }
    setDisabledFilters(newDisabledFilters)
  }

  useEffect(() => {
    checkAvailableFilters()
  }, [filters, carsData])

  const rangeOptions = [
    {
      code: '1-2',
      description: '1-2',
    },
    {
      code: '3-5',
      description: '3-5',
    },
    {
      code: '6-n',
      description: `6 ${dictionary.orMore}`,
    },
  ]

  const filtersList = [
    !fleet && {
      name: 'brand',
      title: dictionary.brand,
      options: brands?.map(({ brandCode, brandLogo, features }) => ({
        code: brandCode,
        description: brandCode,
        image: brandLogo,
        features,
      })),
    },
    {
      name: 'category',
      title: dictionary.category,
      options: categories,
    },
    {
      name: 'type',
      title: dictionary.transmission,
      options: types,
    },
    !fleet && {
      name: 'passengers',
      title: dictionary.passengers,
      options: rangeOptions,
    },
    !fleet && {
      name: 'luggage',
      title: dictionary.luggage,
      options: rangeOptions,
    },
  ].filter((item) => item)

  return (
    <div
      className={`s-filters ${drawer ? 's-filters--drawer' : ''} ${
        isInpath ? 's-filters--inpath' : ''
      }`}>
      <div className="d-flex align-items-center justify-content-between">
        <h3 className="s-filters__title">{dictionary.filtersTitle}</h3>
        {drawer && (
          <button type="button" className="btn p-0" onClick={onCloseDrawer}>
            <i className="icon-x"></i>
          </button>
        )}
      </div>

      {filtersList.map(({ name, title, options }, index) => (
        <Filter
          key={name}
          name={name}
          title={title}
          options={options}
          selectedOptions={filters[name]}
          handleChange={handleChange}
          defaultExpanded={!drawer || index === 0}
          selectedFilters={filters[name]}
          disabledFilters={disabledFilters}
          dictionary={dictionary}
        />
      ))}
      {drawer && !fleet && (
        <div className="s-filters__sort">
          <div className="b-filter__header">
            <h4>{dictionary.sortByLabel}</h4>
          </div>

          {sortOptions?.map((option) => (
            <div
              key={option.value}
              className="b-filter__option b-filter__option--sort">
              <input
                type="radio"
                id={option.value}
                value={option.value}
                checked={option.value === sort}
                onChange={() => dispatch(setSort(option.value))}
              />
              <label htmlFor={option.value} className="form-check-label">
                {option.text}
              </label>
            </div>
          ))}
        </div>
      )}
      {drawer && (
        <div className="s-filters__actions">
          <button
            type="button"
            className="btn s-filters__clear"
            onClick={handleClear}
            title={dictionary.clearAll}>
            {dictionary.clearAll}
          </button>
          <button
            type="button"
            className="btn btn-primary s-filters__apply"
            onClick={handleApply}>
            {dictionary.show} {carsCount} {dictionary.results}
          </button>
        </div>
      )}
    </div>
  )
}

export default Filters

const Filter = ({
  name,
  title,
  options,
  selectedOptions,
  handleChange,
  defaultExpanded,
  selectedFilters,
  disabledFilters,
  dictionary,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)
  const [openBrandsModal, setOpenBrandsModal] = useState(false)

  return (
    <div className="b-filter">
      <div
        className="b-filter__header"
        role="button"
        onClick={() => setIsExpanded((old) => !old)}>
        <h4>{title}</h4>
        {isExpanded ? (
          <i className="icon icon-chevron-up"></i>
        ) : (
          <i className="icon icon-chevron-down"></i>
        )}
      </div>
      <div className={`b-filter__options ${isExpanded ? 'expand' : ''}`}>
        {/* <div className="b-filter__option">
          <input
            type="checkbox"
            id={`${name}-all`}
            checked={selectedOptions?.length === options?.length}
            onChange={() => handleChange(name, 'all')}
          />
          <label htmlFor={`${name}-all`} className="b-filter__label">
            {dictionary.all}
          </label>
        </div> */}
        {options.map((option) => (
          <div key={option.code} className="b-filter__option">
            <input
              type="checkbox"
              className="form-check-input"
              id={`${name}-${option.code}`}
              checked={selectedOptions?.includes(option.code) || false}
              onChange={() => handleChange(name, option.code)}
              disabled={disabledFilters?.includes(`${name}-${option.code}`)}
            />
            <label
              htmlFor={`${name}-${option.code}`}
              className="form-check-label">
              {option.description}
            </label>
            {option.image && (
              <img
                className="b-filter__option__img"
                src={option.image}
                alt={option.description}
              />
            )}
          </div>
        ))}
        {name === 'brand' && (
          <>
            <button
              type="button"
              className="btn b-filter__brand-helper"
              onClick={() => setOpenBrandsModal(true)}
              title={dictionary.whatToChoose}>
              {dictionary.whatToChoose}
            </button>
            <Modal
              open={openBrandsModal}
              onClose={() => setOpenBrandsModal(false)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              disableScrollLock={true}>
              <div className="b-brands-modal">
                <h3 className="b-brands-modal__title">
                  {dictionary.whatToChoose}
                </h3>
                <div className="b-brands-modal__content">
                  {options.map((brand) => (
                    <div key={brand.code} className="b-brands-modal__brand">
                      <img src={brand.image} />
                      <SanitizeHtml html={brand.features} />
                    </div>
                  ))}
                </div>
                <button
                  type="button"
                  className="btn b-brands-modal__close"
                  onClick={() => setOpenBrandsModal(false)}>
                  <i className="icon-x"></i>
                </button>
              </div>
            </Modal>
          </>
        )}
      </div>
      {selectedFilters && (
        <div
          className={`b-filter__selected-labels ${!isExpanded ? 'show' : ''}`}>
          {options
            .filter((opt) => selectedFilters.includes(opt.code))
            ?.map((opt) => opt.description)
            ?.join(', ')}
        </div>
      )}
    </div>
  )
}
